import { anonymousAuth } from '@/lib/auth'
import { JWT_LOCALSTORAGE_KEY } from '@/lib/consts'
import { useEffect, useState } from 'react'
import useAppErrorStore from './useAppErrorStore'

export default function useJWT() {
  const { setError } = useAppErrorStore()

  const [jwt, setJwt] = useState<string | null>(null)

  const register = async () => {
    let token = jwt

    if (!token) {
      const { success, payload } = await anonymousAuth()
      if (!success) {
        setError({
          friendlyError: payload instanceof Error ? payload.message : 'Failed to manage anonymous user',
          error: payload,
        })
      } else {
        token = payload as string
        setJwt(token)
        return token
      }
    }

    return token
  }

  useEffect(() => {
    setJwt(localStorage.getItem(JWT_LOCALSTORAGE_KEY))
  }, [])

  return { register, jwt }
}
